import { render, staticRenderFns } from "./AnalyticsCapacitacion.vue?vue&type=template&id=1c89ff8e&scoped=true"
import script from "./AnalyticsCapacitacion.vue?vue&type=script&lang=js"
export * from "./AnalyticsCapacitacion.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsCapacitacion.vue?vue&type=style&index=0&id=1c89ff8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c89ff8e",
  null
  
)

export default component.exports